// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCart_root__N2u1M"};